import Marquee from "react-fast-marquee";
import { MARQUEE } from "@/data/content";

export default function Ribbon() {
  return (
    <section data-testid="marquee-section" className="bg-[#f1f5f9] py-10 md:py-14 border-y border-[#0f172a]/10 overflow-hidden">
      <Marquee speed={40} gradient gradientColor="#f1f5f9" gradientWidth={120}>
        {MARQUEE.map((item, i) => (
          <span key={i} className="mx-16 inline-flex items-center gap-16">
            <span className="font-serif italic text-2xl md:text-4xl text-[#64748b] whitespace-nowrap">{item}</span>
            <span className="h-1.5 w-1.5 rounded-full bg-[#9c7a4d]" />
          </span>
        ))}
      </Marquee>
    </section>
  );
}
